import { connect } from 'react-redux';
import { App } from 'components/App/App';
import { Global } from 'state/Global';
import { selectPermissionsObject } from 'selectors/permissionsSelector';
import { featureSelectors, networkActions } from '@lifesize/nucleus';
import { actions as CalendarActions } from 'actions/calendarSubscriptionActions';
import { actions as UserStateActions } from 'actions/userStateActions';
import _get from 'lodash/get';

const mapStateToProps = (state: Global) => ({
  permissionsObject: selectPermissionsObject(state)
});

const mapDispatchToProps = (dispatch: Function) => ({
  online: () => {
    dispatch(networkActions.online());
  },
  offline: () => {
    dispatch(networkActions.offline());
  },
  setActive: (active: boolean) => {
    dispatch(UserStateActions.setActivity(active));
  },
  handleCalendarMessage: (event: React.SyntheticEvent) => {
    // there are a lot of 'messages' firing, so filter out the ones we don't want here
    const winId = _get(event, 'data.win_id');
    if (winId) {
      dispatch(CalendarActions.handleCalendarMessage(event));
    }
  }
});

export const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);
